<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chaptertitle"><b>Preface</b></h2>
<p class="body-text">The idea for this book arose from a small recipe and a lot of curiosity. While processing the Logan English papers, held by the University of Kentucky Libraries Special Collections, Andrew McGraw and I pulled a box to get a general sense of what was in the collection. Inside an arbitrary folder from a randomly chosen archival box, we found our first recipe. It had no title but proved to be a delicious combination of zucchini, tomatoes, anchovy, and eggs. This defining moment was followed by a question. Why not compile a cookbook of Kentucky recipes from the archives? We knew there had to be more, and we set off to find them. Our mouths watered at the recipes we found, and we were struck not only by the number of collections containing recipes, but also by the way these recipes were spread out across the history of Kentucky. Finding the recipes was just part of the process. Cooking them was the lure. When we began cooking, the creation of <i>The Historic Kentucky Kitchen: Traditional Recipes for Today's Cook</i> began.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?598a43ad